import { TableCell } from "@mui/material";
import {
  RiskFactorsIcons,
  RiskFactorsIconsProps,
} from "~/pages/space/security/components/RiskFactors/RiskFactorsIcons";

export type RiskFactorsCellProps = {
  riskFactors: RiskFactorsIconsProps["riskFactors"];
  printView?: boolean;
  isActive?: boolean;
  "data-testid"?: string;
};

export const RiskFactorsCell = ({
  riskFactors,
  printView = false,
  isActive = true,
  ...props
}: RiskFactorsCellProps) => {
  return (
    <TableCell data-testid={props["data-testid"]}>
      <RiskFactorsIcons
        riskFactors={riskFactors}
        printView={printView}
        isActive={isActive}
      />
    </TableCell>
  );
};
